module.exports = __webpack_public_path__ + "static/media/blue-cluster.13384a77.svg";